/* eslint-disable multiline-comment-style */
const checksumFromArrayBuffer = require("./utils/checksum-from-arraybuffer.js");
const soundsList = require("./initial-data/sounds.js");

const log = require("../shared_utils/log.js");
const { parseSb3, fetchArrayBuffer } = require("./utils/fetch-and-parse.js");
const getVM = require("./utils/get-vm.js");

function loadGlitchSb3(glitch) {
  return fetchArrayBuffer(
    `/provision/glitches/${glitch.id}/${glitch.id}.sb3`
  ).then((sb3) => {
    log("loaded glitch", glitch.id);
    return Promise.resolve(sb3);
  });
}

function fetchSound(soundName) {
  return fetchArrayBuffer(`/provision/sounds/${soundName}.mp3`).then((mp3) => {
    log("loaded sound", soundName, mp3);
    return Promise.resolve(mp3);
  });
}

function loadPartSb3(part) {
  return fetchArrayBuffer(`/provision/parts/${part.id}/${part.id}.sb3`).then(
    (sb3) => {
      log("loaded part", part.id);
      return Promise.resolve(sb3);
    }
  );
}
module.exports = function loadPartsAndGlitches(state, emitter) {
  emitter.on("load-vm", () => {
    log("load-vm");
    if (window.location.search.includes("fullscreen=true")) {
      emitter.emit("set-fullscreen-mode", true);
    }
    const RENDERER_WIDTH = 960;
    const RENDERER_HEIGHT = 720;
    state.canvas = document.createElement("canvas");
    state.canvas.id = "scratch-canvas";
    state.canvas.width = 480;
    state.canvas.height = 360;
    state.canvas.classList.add("game");
    state.debugCanvas = document.createElement("canvas");
    state.debugCanvas.width = 480;
    state.debugCanvas.height = 360;
    state.debugCanvas.classList.add("game");
    //    state.debugCanvas.style.display = 'none'
    //set position to absolute so that the debug canvas can be positioned over the game canvas
    state.debugCanvas.style.position = "absolute";
    state.debugCanvas.style.top = "0";
    state.debugCanvas.style.left = "0";
    state.debugCanvas.style.zIndex = "100";
    state.debugCanvas.style.pointerEvents = "none";

    state.debugCanvas.id = "debug-canvas";
    state.vm = getVM(state.canvas);
    state.vm.runtime.gamebender = {
      state,
      emitter,
    };
    window.sb3Utils = state.vm.sb3;
    state.vm.renderer.resize(RENDERER_WIDTH, RENDERER_HEIGHT);

    //TODO : Understand why we need the timeout here.  This is a deep choo problem
    setTimeout(() => emitter.emit("render"), 10);
  });

  emitter.on("load-glitches", () => {
    log("load-glitches");
    const subcategories = [];
    state.availableGlitches.forEach((g) => {
      if (g.category) {
        // Only set the color if it hasn't been set yet (first color encountered wins)
        if (!subcategories[g.category]) {
          subcategories[g.category] = {
            id: g.category,
            color: g.color,
          };
        }
      }
    });
    state.glitchCategories = Object.values(subcategories).filter(
      (c) => c.id !== "builtin"
    );
    state.glitchCategories.sort((a, b) => !a.id.localeCompare(b.id));
    const promises = state.availableGlitches.map((glitch) =>
      loadGlitchSb3(glitch).then((sb3) => parseSb3(sb3, state.vm))
    );

    Promise.all(promises).then((results) => {
      results.forEach((parsedGlitch, i) => {
        state.availableGlitches[i].code = parsedGlitch.code;
        state.availableGlitches[i].zip = parsedGlitch.zip;
        state.availableGlitches[i].sb3 = parsedGlitch.sb3;
        state.availableGlitches[i].defaultExposedVariables = JSON.parse(
          JSON.stringify(state.availableGlitches[i].exposedVariables)
        );
        state.availableGlitches[i].checkSum = checksumFromArrayBuffer(
          parsedGlitch.sb3
        );
      });
      state.glitchesLoaded = true;
      emitter.emit("render");
    });
  });

  emitter.on("load-sounds", () => {
    const soundBank = state.vm.runtime.audioEngine?.soundBank || null;

    Promise.all(
      soundsList.map((soundName) =>
        fetchSound(soundName) // Fetch the raw MP3 data
          .then((arrayBuffer) => {
            if (!state.vm.runtime.audioEngine) {
              console.warn(
                "No audio engine available for decoding sound:",
                soundName
              );
              return null;
            }

            // Decode the sound using the Scratch Audio Engine
            return state.vm.runtime.audioEngine
              .decodeSoundPlayer({
                name: soundName,
                data: new Uint8Array(arrayBuffer),
              })
              .then((soundPlayer) => {
                const soundBuffer = soundPlayer.buffer;

                // Create an asset for this sound
                const asset = state.vm.runtime.storage.createAsset(
                  state.vm.runtime.storage.AssetType.Sound,
                  "mp3",
                  new Uint8Array(arrayBuffer),
                  null, // Asset ID is auto-generated
                  true // Mutable asset
                );

                // Construct the sound object
                const soundObject = {
                  name: soundName,
                  assetId: asset.assetId,
                  dataFormat: "mp3",
                  rate: soundBuffer.sampleRate,
                  sampleCount: soundBuffer.length,
                  md5: `${asset.assetId}.mp3`,
                  soundId: soundPlayer.id, // Assign the soundId for playback,
                  asset: asset,
                };

                // Store the sound in the sound library
                state.soundLibrary[soundName] = soundObject;

                // Add the sound player to the sound bank
                if (soundBank) {
                  soundBank.addSoundPlayer(soundPlayer);
                }

                return soundObject;
              });
          })
          .catch((err) => {
            console.error(`Error loading sound "${soundName}":`, err);
            return null;
          })
      )
    ).then((loadedSounds) => {
      // Mark sounds as loaded and trigger a render
      state.soundsLoaded =
        loadedSounds.filter((sound) => sound !== null).length > 0;
      state.vm.gbSoundLibrary = state.soundLibrary;
      emitter.emit("render");
    });
  });

  emitter.on("load-parts", () => {
    log("load-parts");
    const promises = state.availableParts.map((part) =>
      loadPartSb3(part).then((sb3) => parseSb3(sb3, state.vm))
    );
    Promise.all(promises).then((results) => {
      results.forEach((parsedPart, i) => {
        state.availableParts[i].code = parsedPart.code;
        state.availableParts[i].zip = parsedPart.zip;
        state.availableParts[i].sb3 = parsedPart.sb3;
        state.availableParts[i].checkSum = checksumFromArrayBuffer(
          parsedPart.sb3
        );
      });
      state.partsLoaded = true;
      emitter.emit("render");
    });
  });
};
